<template>
  <div class="product-catalog-row" @click.stop="openedPicker = null">
    <div class="products-catalog">
      <div class="catalog-nav-container">
        <div class="catalog-nav">
          <div class="sports-nav" v-if="isReady">
            <div
              class="sports-nav-item"
              :class="{
                active:
                  catalogNav.name.toLowerCase() === catalog.name.toLowerCase(),
              }"
              :title="'Scroll to ' + catalogNav.name"
              @click="
                smoothScrollTo('catalog-' + catalogNav.name.toLowerCase())
              "
              v-for="catalogNav in selectedCatalogs"
              :key="'catalog-nav-' + catalogNav.name"
            >
              {{ catalogNav.name }}
              {{ calcCatalogProductsLength(catalogNav.name) }}
            </div>
          </div>
          <div
            class="catalog-filters"
            v-if="catalogProducts && catalogProducts.length"
          >
            <div class="filter-item filter-bold">Filter By</div>
            <div
              class="filter-item"
              v-for="(filter, index) in filters"
              :key="index"
            >
              <span
                v-if="showFilterItem(filter)"
                class="filter-label"
                @click.stop="togglePicker(filter)"
                >{{
                  filter
                    .replace("filter", "")
                    .replace("_", " ")
                    .replace("Category", "Type")
                }}
                <img
                  class="caret"
                  src="~@/assets/icons/ui/caret-down.svg"
                  :class="{ opened: openedPicker === filter }"
                  :alt="
                    'Toggle ' + filter.replace('filter', '').replace('_', ' ')
                  "
                />
              </span>
              <CheckBoxList
                v-if="showFilterItem(filter)"
                :hasAllOption="true"
                :options="getOptions(filter)"
                :field="filter"
                :openedPicker="openedPicker"
                @selectItem="handleSelectFilter"
                @selectAll="handleSelectAll"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="products-container"
        v-if="catalogProducts != null && catalogProducts.length"
      >
        <template>
          <CatalogueProductCard
            ref="cardsRef"
            v-for="(item, index) in catalogProducts"
            :key="index"
            :item="item"
            :allFilters="allFilters"
          />
        </template>
        <!-- <div class="loader-container" v-else>
          <Loader />
        </div>-->
      </div>
      <div
        class="products-container empty-products-container"
        v-if="!hasCardsShown"
      >
        <p>There are no products that match your current filters.</p>
      </div>
    </div>
  </div>
</template>

<script>
//import Loader from "@/components/Utils/Loader";
import CatalogueProductCard from "@/components/Projects/Showrooms/Catalogue/CatalogueProductCard";
import CheckBoxList from "@/components/Utils/CheckboxList";
import { mapActions, mapState } from "vuex";

export default {
  name: "CatalogRow",
  computed: {
    ...mapState("showroom", [
      "homepageGender",
      "selectedCatalogs",
      "selectedCatalogsProducts",
    ]),

    //  ...mapState("catalog", ["catalogsData"]),

    activeCatalog() {
      return this.selectedCatalogsProducts.find((p) => {
        return p.catalogName === this.catalog.name;
      });
    },

    catalogProducts() {
      return this.activeCatalog?.products;
    },

    getAllAvailableFilters() {
      //
      const products = this.catalogProducts;
      // if (!products?.length) return [];
      const brandFilters = {};
      const categoryFilters = {};
      const genderFilters = {};
      const productionTime = {};

      for (let i = 0; i < products.length; i++) {
        let product = products[i];

        if (!brandFilters[product.brand] && product.brand !== null) {
          brandFilters[product.brand] = product.brand;
        }
        if (!categoryFilters[product.category] && product.category !== null) {
          categoryFilters[product.category] = product.category;
        }
        if (!genderFilters[product.gender] && product.gender !== null) {
          genderFilters[product.gender] = product.gender;
        }
        if (
          !productionTime[product.production_time] &&
          product.production_time !== null
        ) {
          productionTime[product.production_time] = product.production_time;
        }
      }

      return {
        brand: Object.values(brandFilters),
        category: Object.values(categoryFilters),
        gender: Object.values(genderFilters),
        productionTime: Object.values(productionTime),
      };
    },

    filters() {
      return [
        "filterCategory",
        "filterBrand",
        "filterGender",
        "filterProduction_Time",
      ];
    },

    getAllAvailableFiltersData() {
      const filters = this.getAllAvailableFilters;
      const filtersBrand = [];
      const filtersCategory = [];
      const filtersGender = [];
      const filtersProductionTime = [];

      filters.brand?.map((element) => {
        filtersBrand.push({ name: element, checked: true });
      });

      filters.category?.map((element) => {
        filtersCategory.push({ name: element, checked: true });
      });

      filters.gender?.map((element) => {

        let checked = false;
        const genderNiceName = element.replace("'", "").toLowerCase();

        if (
          ["mens", "unisex", "men's", "men"].indexOf(genderNiceName) > -1 &&
          this.homepageGender.indexOf("men") > -1
        ) {
          checked = true;
        } else if (
          ["womens", "unisex", "women's", "women"].indexOf(genderNiceName) >
            -1 &&
          this.homepageGender.indexOf("women") > -1
        ) {
          checked = true;
        }

        filtersGender.push({ name: element, label: element, checked });
      });

      filters.productionTime?.map((element) => {
        filtersProductionTime.push({
          name: element,
          label: `${element} days`,
          checked: true,
        });
      });

      return {
        filterCategory: filtersCategory,
        filterBrand: filtersBrand,
        filterGender: filtersGender,
        filterProduction_Time: filtersProductionTime,
      };
    },
  },

  methods: {
    ...mapActions("project", [
      "setActiveProduct",
      "updateDecorationsForProjectProductsLayouts",
    ]),
    ...mapActions("showroom", ["moveToSingleProductPage"]),

    calcCatalogProductsLength(name) {
      let cat = this.selectedCatalogsProducts.find((p) => {
        return p.catalogName === name;
      });
      return `(${
        cat && cat.products && cat.products.length ? cat.products.length : 0
      })`;
    },

    checkGenderFilterNotEmpty() {
      //If row has at least 1 men or women filter
      if (
        this.getAllAvailableFilters.gender.indexOf("Men's") ||
        this.getAllAvailableFilters.gender.indexOf("Women's")
      ) {
        //we show if at least 1 gender was selected at homepage
        this.hasCardsShown = this.homepageGender?.length;
      } else {
        //row only has youth, girls, adult, etc but no men/women so it doesn't matter what we chose, by default it won't show anything
        this.hasCardsShown = false;
      }
    },

    async calcFilteredProducts() {
      let products = this.catalogProducts;
      if (this.filters?.length) {
        for (
          let filtersIndex = 0;
          filtersIndex < this.filters.length;
          filtersIndex++
        ) {
          const filter = this.filters[filtersIndex];

          const uncheckedFilters = this.allFilters
            ? this.allFilters[filter]?.filter((option) => {
                return option.checked === false;
              })
            : [];

          if (uncheckedFilters?.length > 0) {
            const filterName = filter.replace("filter", "").toLowerCase();
            for (let index = 0; index < uncheckedFilters.length; index++) {
              const unchecked = uncheckedFilters[index];
              products = products?.map((product) => {
                if (
                  product[filterName]?.toString().toLowerCase() !==
                  unchecked?.name?.toString()?.toLowerCase()
                ) {
                  return product;
                }
                return false;
              });
            }
          }
        }
      }
      this.filteredProducts = products?.filter((product) => {
        return product != false;
      });
      this.updateCardsRef();
    },

    getOptions(filterName) {
      return this.allFilters ? this.allFilters[filterName] : null;
    },

    showFilterItem(filterName) {
      if (!this.allFilters) return false;
      return this.getOptions(filterName).length > 0;
    },

    async handleSetActiveProduct(item) {
      await this.setActiveProduct({
        product: { ...item, styleName: item.alias },
        layout: null,
      });

      this.moveToSingleProductPage();
    },

    updateCardsRef() {
      const r = this.$refs.cardsRef?.filter((c) => {
        return c.showCard;
      });
      this.hasCardsShown = r && r.length;
    },

    handleSelectFilter(payload) {
      const field = this.allFilters[payload.field];

      for (let index = 0; index < field.length; index++) {
        const item = field[index];
        if (item.name === payload.option) {
          this.allFilters[payload.field][index].checked =
            !this.allFilters[payload.field][index].checked;
        }
      }

      this.calcFilteredProducts();
    },

    handleSelectAll(payload) {
      const field = this.allFilters[payload.field];

      for (let index = 0; index < field.length; index++) {
        this.allFilters[payload.field][index].checked = !payload.checked;
      }

      this.calcFilteredProducts();
    },

    togglePicker(filterName) {
      this.openedPicker = this.openedPicker === filterName ? null : filterName;
    },

    smoothScrollTo(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
  },
  components: {
    CheckBoxList,
    CatalogueProductCard,
    // Loader,
  },
  watch: {
    allFilters: {
      handler() {
        if (!this.firstLoad) {
          this.firstLoad = true;
        } else {
          this.updateCardsRef();
        }
      },
      deep: true,
    },
  },
  props: {
    //selectedCatalogs: {
    // type: Array,
    //},
    catalog: {
      type: Object,
    },
    catalogIndex: {
      required: false,
    },
  },

  async mounted() {
    const ind = this.catalogIndex * 1;
    setTimeout(async () => {
      this.isReady = true;
      //await this.fetchProductsFromCatalog(this.catalog.name);
      //await this.calcFilteredProducts();
      this.allFilters = await this.getAllAvailableFiltersData;
      this.checkGenderFilterNotEmpty();
      //this.updateDecorationsForProjectProductsLayouts();
    }, 1000 * ind);
  },

  created() {
    //this.allFilters = this.getAllAvailableFiltersData;
  },

  data() {
    return {
      hasCardsShown: true,
      filteredProducts: [],
      openedPicker: null,
      allFilters: null,
      isReady: false,
      firstLoad: false,
    };
  },
};
</script>

<style lang="scss" scoped>
#app {
  .catalog-nav-container {
    display: flex;
    justify-content: center;
    // border-bottom: 1px solid #f4f4f5;
    // border-top: 1px solid #f4f4f5;
    .catalog-nav {
      width: 1440px;
      display: flex;
      justify-content: space-between;
      padding: 15px;

      .sports-nav {
        display: flex;
        flex-wrap: wrap;
        max-width: 60%;
        .sports-nav-item {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 8px 16px;
          border-radius: 56px;
          background: #ffffff;
          border: 1px solid #d8dadf;
          box-sizing: border-box;
          color: #000;
          font-size: 14px;
          line-height: 17px;
          letter-spacing: 0.03em;
          margin: 5px;
          cursor: pointer;

          &.active {
            border: 1px solid #26262c;
            background: #26262c;
            color: #fff;
          }
        }
      }
    }
  }

  .products-container {
    display: flex;
    flex-wrap: wrap;
    max-width: 1440px;
    margin: 0 auto;
    justify-content: center;

    &.empty-products-container {
      padding: 100px;
    }

    .loader-container {
      padding: 10em;
    }
  }
  .catalog-filters {
    display: flex;
    align-items: center;

    .filter-item {
      position: relative;
      padding: 0 20px;
      display: flex;
      align-items: center;

      .filter-label {
        font-size: 14px;
        line-height: 130%;
        color: #6d7283;
        cursor: pointer;

        .caret {
          margin-left: 5px;
          transition: all 0.15s;
          transform: rotate(0);

          &.opened {
            transform: rotate(180deg);
          }
        }
      }

      .labels-in-column {
        display: flex;
        align-items: center;
        margin: 0 10px;
      }
    }
  }
}
</style>